import { Input, Select, Button, Typography, Space } from "antd";
const { Option } = Select;
const { Text } = Typography;

export function FiltersComponentAntd({ filters, opcionesFiltros, totalRegistros, registrosFiltrados, onUpdateFilter, onLimpiarFiltros }) {
  const hayFiltrosAplicados =
    filters.texto ||
    filters.departamento !== "0" ||
    filters.municipio !== "0" ||
    filters.tipoNovedad !== "0";


  const tiposNovedadMap = {
    1: 'Fallecimiento',
    2: 'Retiro Voluntario',
    3: 'Exclusión',
    4: 'Corrección o actualización de información',
    5: 'Otra',
  };


  return (
    <div style={{ marginBottom: 24 }}>
      <Space
      wrap
      align="end"
      size={[24, 24]}
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 8,
      }}
    >
        <div style={{ width: 300 }}>
          <label htmlFor="filtroTexto">Participante o cédula</label>
          <Input
            id="filtroTexto"
            placeholder="Nombre o cédula"
            value={filters.texto}
            onChange={(e) => onUpdateFilter("texto", e.target.value)}
            allowClear
          />
        </div>

        <div style={{ width: 250 }}>
          <label htmlFor="filtroDepartamento">Departamento</label>
          <Select
            id="filtroDepartamento"
            value={filters.departamento}
            onChange={(value) => onUpdateFilter("departamento", value)}
            style={{ width: "100%" }}
            allowClear
          >
            <Option value="0">Todos</Option>
            {opcionesFiltros.departamentos.map((dept) => (
              <Option key={dept} value={dept}>
                {dept}
              </Option>
            ))}
          </Select>
        </div>

        <div style={{ width: 250 }}>
          <label htmlFor="filtroMunicipio">Municipio</label>
          <Select
            id="filtroMunicipio"
            value={filters.municipio}
            onChange={(value) => onUpdateFilter("municipio", value)}
            style={{ width: "100%" }}
            allowClear
          >
            <Option value="0">Todos</Option>
            {opcionesFiltros.municipios.map((mun) => (
              <Option key={mun} value={mun}>
                {mun}
              </Option>
            ))}
          </Select>
        </div>

        <div style={{ width: 250 }}>
          <label htmlFor="filtroTipoNovedad">Tipo de Novedad</label>
          <Select
            id="filtroTipoNovedad"
            value={filters.tipoNovedad}
            onChange={(value) => onUpdateFilter("tipoNovedad", value)}
            style={{ width: "100%" }}
            allowClear
          >
            <Option value="0">Todos</Option>
            {Object.entries(tiposNovedadMap).map(([value, label]) => (
              <Option key={value} value={value}>
                {label}
              </Option>
            ))}

          </Select>
        </div>

        <div style={{ width: 120 }}>
          <Button onClick={onLimpiarFiltros} type="default" block>
            Limpiar
          </Button>
        </div>
      </Space>


      <div
      className="participant-count-container"
      style={{ marginTop: 16, width: "100%", boxSizing: "border-box" }}
    >
        <h1 className="participant-count-title">
          Número de Registros: {totalRegistros} - Mostrando: {registrosFiltrados}
          <span className="participant-count-number">
            {hayFiltrosAplicados && (
              <Text style={{ marginLeft: 8 }} type="warning">
                (filtros aplicados)
              </Text>
            )}
          </span>
        </h1>
      </div>
    </div>
  );
}